projectFunctions.productGalleryVideoFunctions = projectFunctions.productGalleryVideoFunctions || {};

/**
 * Init: Will be triggered on document ready.
 */
projectFunctions.productGalleryVideoFunctions.init = function() {
    this.fixViewportHeight();
    this.addPlayIcon();
    this.updateFirstThumbnailSrc();
};

projectFunctions.productGalleryVideoFunctions.fixViewportHeight = function () {
    var video = $('.woocommerce-product-gallery__video video');

    if (video.length) {
      video.on('loadedmetadata', function() {
        var $viewport = $('.flex-viewport');
        var $gallery = $('.woocommerce-product-gallery');
  
        if ($viewport.length && $gallery.data('flexslider')) {
          // Trigger FlexSlider to recalculate dimensions
          $(window).trigger('resize');
        }
      });
  
      // Also handle case where video is already loaded
      if (video[0].readyState >= 1) {
        $(window).trigger('resize');
      }
    }
}

projectFunctions.productGalleryVideoFunctions.addPlayIcon = function () {
    function addVideoPlayOverlay() {
        $('.flex-control-thumbs li').each(function() {
          var $li = $(this);
          var $img = $li.find('img[alt="Product Video"]');
    
          // Only add overlay if it's a video thumbnail and doesn't already have one
          if ($img.length && !$li.find('.video-play-overlay').length) {
            $li.append('<div class="video-play-overlay"></div>');
          }
        });
    }
    
    // Run after FlexSlider initializes (small delay to ensure thumbnails are rendered)
    setTimeout(addVideoPlayOverlay, 500);

    // Also run when window is loaded (backup)
    $(window).on('load', addVideoPlayOverlay);
}

projectFunctions.productGalleryVideoFunctions.updateFirstThumbnailSrc = function () {
    var $form = $('form.variations_form');

  if (!$form.length) {
    return;
  }

  // Store original srcset
  var originalSrcset = null;

  function storeOriginalSrcset() {
    var $firstThumb = $('.flex-control-thumbs li:first-child img');
    if ($firstThumb.length && originalSrcset === null) {
      originalSrcset = $firstThumb.attr('srcset') || '';
    }
  }

  // Store on page load
  setTimeout(storeOriginalSrcset, 600);

  // When variation is found, also update srcset on first thumbnail
  $form.on('found_variation', function(_event, variation) {
    var $firstThumb = $('.flex-control-thumbs li:first-child img');

    if (!$firstThumb.length || !variation.image) {
      return;
    }

    storeOriginalSrcset();

    // Clear srcset so browser uses src instead
    // WooCommerce already updates src, but srcset takes priority
    $firstThumb.removeAttr('srcset');
  });

  // Restore srcset on reset
  $form.on('reset_data', function() {
    var $firstThumb = $('.flex-control-thumbs li:first-child img');

    if ($firstThumb.length && originalSrcset) {
      $firstThumb.attr('srcset', originalSrcset);
    }
  });
}